<template>
  <v-card>
    <v-card-title class="headline">
      {{ title }}
    </v-card-title>
    <v-card-text>
      <slot name="card-content">
        <p v-for="(paragraph, i) in content" :key="i">{{ paragraph }}</p>
      </slot>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <text-button @click="close">OK</text-button>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconButton from '@/components/button/IconButton.vue';
import TextButton from '@/components/button/TextButton.vue';

@Component({
  components: { TextButton, IconButton },
})
export default class DialogCard extends Vue {
  @Prop(String) readonly title: string | undefined;
  @Prop(Array) readonly content: string[] | undefined;

  close() {
    this.$emit('close');
  }
}
</script>